// extracted by mini-css-extract-plugin
module.exports = {"loaderOverlay":"VideoLoader_loaderOverlay__dWqsj","loader":"VideoLoader_loader__SFDAY","spin":"VideoLoader_spin__1cGZT","loaderText":"VideoLoader_loaderText__2pgL6"};